export class EventService {
  private readonly eventTarget: EventTarget

  constructor() {
    this.eventTarget = new EventTarget()
  }

  static getInstance(): EventService {
    if (!globalThis.__eventService) {
      globalThis.__eventService = new EventService()
    }
    return globalThis.__eventService
  }

  emit(eventName: string, detail?: any) {
    const event = new CustomEvent(eventName, { detail })
    this.eventTarget.dispatchEvent(event)
  }

  on(eventName: string, callback: (event: CustomEvent) => void) {
    this.eventTarget.addEventListener(eventName, callback as EventListener)
  }

  off(eventName: string, callback: (event: CustomEvent) => void) {
    this.eventTarget.removeEventListener(eventName, callback as EventListener)
  }
}
